<template>
  <div class="row">
    <div class="col-12">
      <h3 class="page-heading">Dashboard</h3>
      <div class=" clsContainer">
        <div class="row mainStory">
          <div class="col-md-4 card_item card__item">
            <div class="decisionTree" @click="goDecisionTree('mainStoryView')">
              <h5>Decision Tree</h5>
            </div>
          </div>
          <div class="col-md-4 card__item">
             <div class="decisionTree" @click="goSettings()" >
              <h5>Settings</h5>
            </div>
          </div>
          <div class="col-md-4 card__item">
            <div class="decisionTree" @click="goDecisionTree('globalLogicEditView')">
              <h5>Global Logic</h5>
            </div>
          </div>
          <div class="col-md-4 card__item">
            <div class="decisionTree clsBottom"><h5>Moodboard</h5></div>
          </div>
          <div class="col-md-4 card__item">
            <div class="decisionTree clsBottom">
              <h5>
                Assets
              </h5>
            </div>
          </div>
          <div class="col-md-4 card__item">
            <div class="decisionTree clsBottom"><h5>Overlay</h5></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({
    projectId: "",
    projectName: "",
    storyId: "",
  }),
  mounted: function () {
    this.loadInitialData();
    this.$store.dispatch("updateStoryID", {
      title: this.$route.query.title,
      id: this.$route.query.id,
    });
    localStorage.setItem("storyId", this.$route.query.id);
  },
  computed: {},
  methods: {
    loadInitialData() {
      this.projectName = this.$route.query.title;
      this.projectId = this.$route.query.id;
    },
    goDecisionTree() {
      this.$router.push({ name: "mainStoryView" });
    },
    goSettings() {
      this.$router.push("/newprofile/update-story/step-1");
    },
    goDecisionTree(routername) {
      this.$router.push({ name: routername });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.clsContainer {
  background-color: #fff !important;
  border-radius: 0.428rem;
  border: 0 solid rgba(34, 41, 47, 0.125);
  color: #4d4b4b !important;
  border: 1px solid #c6c6c6;
  margin: 20px auto;
  padding: 50px !important;
  display : flex;
  align-items: center;
  justify-content: center;
}
.container {
  cursor: pointer;
}
.container a {
  text-decoration: underline;
}
.container h5 {
  text-align: center;
  margin: 35px auto;
}
.decisionTree {
  height: 100px;
  width: 150px;
  // border: 1px solid #ffffff;
  border-radius: 0.428rem;
  margin: 0 auto;
  background-color: #7367F0;
  box-shadow: 0 3px 6px 0 #7367f066;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.overlay {
  height: 100px;
  width: 150px;
  border: 1px solid #c6c6c6;
  border-radius: 10px 10px;
  background-color: #5dc3b9;
  color: #ffffff;
}
.universalRule {
  height: 100px;
  width: 150px;
  border: 1px solid #c6c6c6;
  border-radius: 10px 10px;
  background-color: #dfefe8;
}
.universalRule:hover {
  background-color: #469b6e;
  color: #fff;
}
.mainStory {
      width: 46rem;
}

.clsBottom {
  h5 {
    text-decoration: line-through;
  }
}
.moodBoard {
  height: 100px;
  width: 150px;
  border: 1px solid #c6c6c6;
  border-radius: 10px 10px;
  margin : 0 auto;
  background-color: #5dc3b9;
  color: #ffffff;
  
}


.assets {
  height: 100px;
  width: 150px;
  border: 1px solid #c6c6c6;
  border-radius: 10px 10px;
  background-color: #fff;
  color: #6d6565;
}

.assets:hover {
  background-color: #469b6e;
  color: #fff;
}

.setup {
  height: 100px;
  width: 150px;
  border: 1px solid #c6c6c6;
  border-radius: 10px 10px;
  background-color: #fff;
  color: #6d6565;
}

.setup:hover {
  background-color: #469b6e;
  color: #fff;
}
.clsMainStroy {
  margin-top: -30px;
}
.clsSpecifc {
  font-size: 10px;
}
.card__item {
  padding : .5rem ;
}
</style>



// WEBPACK FOOTER //
// src/views/ProjectDashboard.vue